type Props = {
  className: string;
};
const LoadingSkeleton = ({ className }: Props) => {
  return (
    <div
      className={`bg-gray-500 animate-[pulse_1s_infinite_ease-in-out] rounded-sm ${className}`}
    />
  );
};

export default LoadingSkeleton;
